import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Paper, Stepper, Step, StepLabel, StepContent } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { MENU_WIDTH } from '../constants';
import Connection from '../components/Provisioning/Connection';
import Patient from '../components/Provisioning/Patient';
import Complete from '../components/Provisioning/Complete';
import { linkDevice } from '../store/actions/devices';
import { getCurrentUser } from '../store/actions/auth';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    paddingLeft: MENU_WIDTH,
    paddingTop: '6rem',
  },
  title: {
    margin: '2rem 0 0 2rem',
  },
  paper: {
    margin: '2em',
    height: '100%',
  },
  stepContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  buttonRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  button: {
    marginLeft: '2em',
  },
}));

const Provision = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = useState(0);
  const [nextDisabled, setNextDisabled] = useState(false);
  const [device, setDevice] = useState(null);
  const [patient, setPatient] = useState(null);

  const stepLabels = ['Monitor Connection', 'Verify Patient Information', 'Complete'];
  const stepContents = [
    <Connection setDevice={setDevice} device={device} />,
    <Patient device={device} setPatient={setPatient} patient={patient} />,
    <Complete />,
  ];

  useEffect(() => {
    dispatch(getCurrentUser());
  }, [dispatch]);

  useEffect(() => {
    if (activeStep === 0 && !device) setNextDisabled(true);
    else if (activeStep === 1 && !patient) setNextDisabled(true);
    else setNextDisabled(false);
  }, [activeStep, device, patient]);

  const handleNext = useCallback(() => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  }, [activeStep]);

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleDone = () => {
    dispatch(linkDevice(device.id, patient.id));
    history.push('./patients');
    toast.success(`Monitor has been successfully linked to patient.`, {
      position: 'bottom-left',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      theme: 'colored',
    });
  };

  return (
    <div className={classes.root}>
      <h2 className={classes.title}>Link Patient & Monitor</h2>
      <Paper className={classes.paper}>
        <Stepper activeStep={activeStep} orientation="vertical">
          {stepLabels.map((label, index) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
              <StepContent>
                <div className={classes.stepContent}>{stepContents[index]}</div>
                <div className={classes.buttonRow}>
                  {index !== 0 && (
                    <Button className={classes.button} onClick={handleBack}>
                      Back
                    </Button>
                  )}
                  {index < stepLabels.length - 1 && (
                    <Button
                      className={classes.button}
                      disabled={nextDisabled}
                      color="primary"
                      variant="contained"
                      onClick={handleNext}
                    >
                      Continue
                    </Button>
                  )}
                  {index === stepLabels.length - 1 && (
                    <Button className={classes.button} color="primary" variant="contained" onClick={handleDone}>
                      Done
                    </Button>
                  )}
                </div>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Paper>
    </div>
  );
};

export default Provision;
